import React from 'react';
import ZTextArea from '../../z-text-area';
import PhotoPreview from '../../shared/components/content-image'
import Section from './section';
import style from './content.module.scss';
import ZDraggableGrid from '../../z-draggable-grid.js';
import ZAddButton from '../../z-button-add';
import { getImagePreviewTransformation } from '../../../utils/image/image-utils';

const ContentView = ({
  addSection,
  headerPhotoId,
  id,
  moveToBottom,
  moveToTop,
  onAddSectionClick,
  onChangePhoto,
  onChangePosition,
  onCreateHeaderPhoto,
  onCreateSectionPhoto,
  onDeleteHeaderPhoto,
  onDeleteSectionPhoto,
  onDragEnd,
  onRemoveSectionClick,
  onSectionTextChange,
  onSectionTitleChange,
  onSummaryChange,
  onTopArticleClick,
  photos,
  readOnly,
  sections,
  summary,
  targetEle,
}) => {
  return (
    <>
      <br/>
      <h2>Header Photo</h2>
      <div className={style['hero-image']}>
        {/** @TODO Resolve Errors */}
        {/* {props.errors.heroImage &&
          <p className={sharedStyle['error']}>{props.errors.heroImage.message}</p>
        } */}
        <PhotoPreview
          entityId={id}
          photoId={headerPhotoId}
          style={{marginBottom: '14px', borderBottom: '1px solid rgba(255, 145, 0,0.5)', paddingBottom: '7px'}}
          showInfo
          onChangePhoto={onChangePhoto}
          onCreatePhoto={onCreateHeaderPhoto}
          onRemovePhoto={onDeleteHeaderPhoto}
          photo={photos[headerPhotoId]}
          transformation={getImagePreviewTransformation({ aspectRatio: 1.5 })}
        />
      </div>
      <br/>
      <ZTextArea
        allowedFormats={['LINKS']}
        label="Introduction"
        onUpdate={onSummaryChange}
        value={summary}
      />
      <div className={style['add-section']}>
        <ZAddButton onClick={onTopArticleClick}>Add Section</ZAddButton>
      </div>
      <br/>
      <ZDraggableGrid onDragEnd={onDragEnd} disabled={readOnly}>
        { sections.map( (ele, index) => (
          <Section
            key={ele.id}
            title={ele.title}
            text={ele.text}
            id={ele.id}
            moveToBottom={moveToBottom}
            moveToTop={moveToTop}
            order={index + 1}
            index={index}
            onChangePosition={onChangePosition}
            onSectionTitleChange={onSectionTitleChange}
            onSectionTextChange={onSectionTextChange}
            onRemoveSectionClick={onRemoveSectionClick}
            onAddSectionClick={onAddSectionClick}
            onChangePhoto={onChangePhoto}
            onCreatePhoto={onCreateSectionPhoto}
            onRemovePhoto={onDeleteSectionPhoto}
            photo={photos[ele.photoId] || {}}
        />
        ))}
      </ZDraggableGrid>
      <div ref={targetEle}/>
      <br/>
      <div className={style['add-section']}>
        <ZAddButton onClick={addSection}>Add Section</ZAddButton>
      </div>
    </>
  )
}

export default ContentView;
